import { call, put, select } from 'redux-saga/effects';
import { eventsCategories } from '../constants/eventsCategories';
import { getEventsFilters, getEventSortDesc } from '../selectors/eventsSelectors';

import {
  fetchEventDetails,
  fetchEvents,
  fetchEventTitles,
  fetchEventSessions,
  fetchSessionDetails,
  fetchEventsProperties,
} from '../services/eventsService';
import { EventFilters, EventsAction, EventsActionType, Response } from '../types/eventsTypes';

export function* fetchEventsSaga({ payload }: EventsAction): Generator {
  try {
    const filters = (yield select(getEventsFilters)) as EventFilters;
    const sortDesc = (yield select(getEventSortDesc)) as boolean;
    const events = yield call(() =>
      fetchEvents(filters.category, filters.timeline, sortDesc, payload.status, filters.favourites),
    );

    yield put({ type: EventsActionType.FETCH_EVENTS_SUCCESS, payload: { events } });
  } catch (response) {
    yield put({ type: EventsActionType.FETCH_EVENTS_ERROR, payload: response });
  }
}

export function* fetchEventPropertiesSaga(): Generator {
  try {
    const response = (yield call(fetchEventsProperties)) as Response;

    const properties = {
      categories: Object.entries(eventsCategories).map(([id, name]) => ({ id, name })),
      segments: response.data.segments,
      productLines: response.data.productLines,
      industries: response.data.industries,
      regions: response.data.regions,
      locations: [
        { id: 'webinar', name: 'Web conference' },
        { id: 'onsight', name: 'Onsight' },
      ],
    };

    yield put({ type: EventsActionType.FETCH_EVENT_PROPERTIES_SUCCESS, payload: { properties } });
  } catch (response) {
    yield put({ type: EventsActionType.FETCH_EVENT_PROPERTIES_ERROR, payload: response });
  }
}

export function* fetchEventDetailsSaga({ payload }: EventsAction): Generator {
  try {
    const response = yield call(() => fetchEventDetails(payload));

    yield put({
      type: EventsActionType.FETCH_EVENT_DETAILS_SUCCESS,
      payload: { id: payload, data: response },
    });
  } catch (response) {
    yield put({ type: EventsActionType.FETCH_EVENT_DETAILS_ERROR, payload: response });
  }
}

export function* fetchEventTitlesSaga({ payload }: EventsAction): Generator {
  try {
    const response = (yield call(() => fetchEventTitles(payload))) as Response;

    yield put({ type: EventsActionType.FETCH_EVENT_TITLES_SUCCESS, payload: response.data });
  } catch (response) {
    yield put({ type: EventsActionType.FETCH_EVENT_TITLES_ERROR, payload: response });
  }
}

export function* fetchEventSessionsSaga({ payload }: EventsAction): Generator {
  try {
    const response = (yield call(() => fetchEventSessions(payload))) as Response;

    yield put({
      type: EventsActionType.FETCH_EVENT_SESSIONS_SUCCESS,
      payload: { id: payload, data: response.data },
    });
  } catch (response) {
    yield put({ type: EventsActionType.FETCH_EVENT_SESSIONS_ERROR, payload: response });
  }
}

export function* fetchSessionDetailsSaga({ payload }: EventsAction): Generator {
  try {
    const response = yield call(() => fetchSessionDetails(payload));

    yield put({
      type: EventsActionType.FETCH_SESSION_DETAILS_SUCCESS,
      payload: { id: payload, data: response },
    });
  } catch (response) {
    yield put({ type: EventsActionType.FETCH_SESSION_DETAILS_ERROR, payload: response });
  }
}
